import React from 'react';
import { makeStyles } from '@mui/styles';
import {Loaders} from "@chkp/ci-front-common-core";

function SMCPageLoading() {
    const classes = useStyles();
    return (
        <div className={classes.root}>
            <Loaders.Dots />
        </div>
    );
}

const useStyles = makeStyles({
    root: {
        height: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontSize: '13px'
    }
})

export default React.memo(SMCPageLoading);